"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAcquisitionRun = exports.toAcquisition = exports.displayAcquisitionRequestId = exports.padStageOrder = exports.normalizeAcquisitionName = exports.getAcquisitionStageSpreadsheetFields = exports.PRICE_BOOK_SOURCE_SPREADSHEET_HELPER = exports.PRICE_PLAN_SOURCE_SPREADSHEET_HELPER = exports.SUBSCRIPTION_PLAN_SOURCE_SPREADSHEET_HELPER = exports.SUBSCRIPTION_PLAN_SOURCE_SHEET = exports.ITEMS_SOURCE_SPREADSHEET_HELPER = exports.ITEMS_SOURCE_SHEET = exports.PENDING_ACTIVATION_FIN28_HELPER = exports.PENDING_ACTIVATION_FIN8_HELPER = exports.LINK_CONTRACTUAL_DOC_FIN27_HELPER = exports.LINK_CONTRACTUAL_DOC_FIN8_HELPER = exports.CONTRACTUAL_DOC_FIN27_HELPER = exports.CONTRACTUAL_DOC_FIN8_HELPER = exports.SUBSCRIPTION_FIN27_HELPER = exports.SUBSCRIPTION_FIN8_HELPER = exports.BILLING_ACCOUNT_FIN28_HELPER = exports.BILLING_ACCOUNT_FIN8_HELPER = exports.FIN_27_SHEET = exports.FIN_28_SHEET = exports.FIN_8_SHEET = exports.CUSTOMER_SOURCE_SPREADSHEET_HELPER = exports.CUSTOMER_SOURCE_REQUIRED_SHEETS = exports.CUSTOMER_SOURCE_FIN_20_SHEET = exports.CUSTOMER_SOURCE_FIN_23_SHEET = exports.getAcquisitionImportStage = exports.ACQUISITION_IMPORT_STAGES = exports.ACQ_LIST_GSI_PK = exports.ACQ_RUN_QUEUE_PREFIX = exports.ACQ_NAME_PREFIX = exports.ACQ_PREFIX = void 0;
exports.ACQ_PREFIX = "ACQ";
exports.ACQ_NAME_PREFIX = "ACQNAME";
exports.ACQ_RUN_QUEUE_PREFIX = "ACQRUN";
exports.ACQ_LIST_GSI_PK = "ACQ#LIST";
/** Playbook order. Users may still submit any stage; worker uses this for queue order. */
exports.ACQUISITION_IMPORT_STAGES = [
    { code: "customers", label: "Customers", order: 10 },
    { code: "vendors", label: "Vendors", order: 20 },
    { code: "billing_accounts", label: "Billing Accounts", order: 30 },
    { code: "items", label: "Items", order: 40 },
    { code: "sub_plan", label: "Subscription Plan", order: 50 },
    { code: "price_plans", label: "Price Plans", order: 60 },
    { code: "price_books", label: "Price Books", order: 70 },
    { code: "subscriptions", label: "Subscriptions", order: 80 },
    { code: "contractual_docs", label: "Contractual Documents", order: 90 },
    {
        code: "link_contractual_docs",
        label: "Link Contractual Document To Subscription",
        order: 100,
    },
    {
        code: "pending_activation_lines",
        label: "Change Line To Pending Activation",
        order: 110,
    },
    {
        code: "activate_lines",
        label: "Activate Subscription Lines",
        order: 120,
    },
    { code: "terminate_lines", label: "Terminate Lines", order: 130 },
    { code: "charge_qc", label: "Charge QC", order: 140 },
    { code: "bill_run", label: "Bill Run", order: 150 },
    { code: "intpreacq_invoices", label: "INTPREACQ Invoices / CMs", order: 160 },
    { code: "open_ar", label: "Open AR", order: 170 },
    { code: "open_ap", label: "Open AP", order: 180 },
];
function getAcquisitionImportStage(code) {
    return exports.ACQUISITION_IMPORT_STAGES.find((stage) => stage.code === code);
}
exports.getAcquisitionImportStage = getAcquisitionImportStage;
/** Input-workbook tabs the Customers stage reads. Spreadsheet file name is not checked. */
exports.CUSTOMER_SOURCE_FIN_23_SHEET = "A: FIN_23 Customer Details";
exports.CUSTOMER_SOURCE_FIN_20_SHEET = "A: FIN_20 - Legal Entity Details";
exports.CUSTOMER_SOURCE_REQUIRED_SHEETS = [
    exports.CUSTOMER_SOURCE_FIN_23_SHEET,
    exports.CUSTOMER_SOURCE_FIN_20_SHEET,
];
exports.CUSTOMER_SOURCE_SPREADSHEET_HELPER = 'P_FIN_4 spreadsheet having sheets "' +
    exports.CUSTOMER_SOURCE_FIN_23_SHEET +
    '" and "' +
    exports.CUSTOMER_SOURCE_FIN_20_SHEET +
    '"';
exports.FIN_8_SHEET = "FIN_8 - Customer Contracts";
exports.FIN_28_SHEET = "B: FIN_28 - Customer Contract Line Items";
exports.FIN_27_SHEET = "B: FIN_27 - Customer Contracts";
exports.BILLING_ACCOUNT_FIN8_HELPER = 'P_FIN_2 spreadsheet having sheet "' + exports.FIN_8_SHEET + '"';
exports.BILLING_ACCOUNT_FIN28_HELPER = 'P_FIN_4 spreadsheet having sheet "' + exports.FIN_28_SHEET + '"';
exports.SUBSCRIPTION_FIN8_HELPER = exports.BILLING_ACCOUNT_FIN8_HELPER;
exports.SUBSCRIPTION_FIN27_HELPER = 'P_FIN_4 spreadsheet having sheets "' +
    exports.FIN_27_SHEET +
    '" and "' +
    exports.FIN_28_SHEET +
    '"';
exports.CONTRACTUAL_DOC_FIN8_HELPER = exports.SUBSCRIPTION_FIN8_HELPER;
exports.CONTRACTUAL_DOC_FIN27_HELPER = exports.SUBSCRIPTION_FIN27_HELPER;
exports.LINK_CONTRACTUAL_DOC_FIN8_HELPER = exports.CONTRACTUAL_DOC_FIN8_HELPER;
exports.LINK_CONTRACTUAL_DOC_FIN27_HELPER = exports.CONTRACTUAL_DOC_FIN27_HELPER;
exports.PENDING_ACTIVATION_FIN8_HELPER = exports.BILLING_ACCOUNT_FIN8_HELPER;
exports.PENDING_ACTIVATION_FIN28_HELPER = exports.BILLING_ACCOUNT_FIN28_HELPER;
/** Input-workbook tab the Items stage reads. Tab title is exact, not case-insensitive. */
exports.ITEMS_SOURCE_SHEET = "Item";
exports.ITEMS_SOURCE_SPREADSHEET_HELPER = 'Spreadsheet link having CSV data already ready for upload in sheet "' +
    exports.ITEMS_SOURCE_SHEET +
    '"';
/** Input-workbook tab the Subscription Plan stage reads. Tab title is exact, not case-insensitive. */
exports.SUBSCRIPTION_PLAN_SOURCE_SHEET = "Subscription_Plan";
exports.SUBSCRIPTION_PLAN_SOURCE_SPREADSHEET_HELPER = 'Spreadsheet link having CSV data already ready for upload in sheet "' +
    exports.SUBSCRIPTION_PLAN_SOURCE_SHEET +
    '"';
exports.PRICE_PLAN_SOURCE_SPREADSHEET_HELPER = 'P_FIN_2 spreadsheet having sheet "' + exports.FIN_8_SHEET + '"';
exports.PRICE_BOOK_SOURCE_SPREADSHEET_HELPER = exports.PRICE_PLAN_SOURCE_SPREADSHEET_HELPER;
/** Queue-dialog spreadsheet fields. Other stages stay a single generic URL until defined. */
function getAcquisitionStageSpreadsheetFields(stageCode) {
    if (stageCode === "customers") {
        return [
            {
                key: "spreadsheetUrl",
                label: "P_FIN_4 spreadsheet",
                helperText: exports.CUSTOMER_SOURCE_SPREADSHEET_HELPER,
                requiredSheetTitles: [...exports.CUSTOMER_SOURCE_REQUIRED_SHEETS],
            },
        ];
    }
    if (stageCode === "billing_accounts") {
        return [
            {
                key: "fin8SpreadsheetUrl",
                label: "P_FIN_2 spreadsheet",
                helperText: exports.BILLING_ACCOUNT_FIN8_HELPER,
                requiredSheetTitles: [exports.FIN_8_SHEET],
            },
            {
                key: "fin28SpreadsheetUrl",
                label: "P_FIN_4 spreadsheet",
                helperText: exports.BILLING_ACCOUNT_FIN28_HELPER,
                requiredSheetTitles: [exports.FIN_28_SHEET],
            },
        ];
    }
    if (stageCode === "items") {
        return [
            {
                key: "spreadsheetUrl",
                label: "Spreadsheet URL",
                helperText: exports.ITEMS_SOURCE_SPREADSHEET_HELPER,
                requiredSheetTitles: [exports.ITEMS_SOURCE_SHEET],
            },
        ];
    }
    if (stageCode === "sub_plan") {
        return [
            {
                key: "spreadsheetUrl",
                label: "Spreadsheet URL",
                helperText: exports.SUBSCRIPTION_PLAN_SOURCE_SPREADSHEET_HELPER,
                requiredSheetTitles: [exports.SUBSCRIPTION_PLAN_SOURCE_SHEET],
            },
        ];
    }
    if (stageCode === "price_plans" || stageCode === "price_books") {
        return [
            {
                key: "spreadsheetUrl",
                label: "P_FIN_2 spreadsheet",
                helperText: stageCode === "price_books"
                    ? exports.PRICE_BOOK_SOURCE_SPREADSHEET_HELPER
                    : exports.PRICE_PLAN_SOURCE_SPREADSHEET_HELPER,
                requiredSheetTitles: [exports.FIN_8_SHEET],
            },
        ];
    }
    if (stageCode === "pending_activation_lines") {
        return [
            {
                key: "fin8SpreadsheetUrl",
                label: "P_FIN_2 spreadsheet",
                helperText: exports.PENDING_ACTIVATION_FIN8_HELPER,
                requiredSheetTitles: [exports.FIN_8_SHEET],
            },
            {
                key: "fin28SpreadsheetUrl",
                label: "P_FIN_4 spreadsheet",
                helperText: exports.PENDING_ACTIVATION_FIN28_HELPER,
                requiredSheetTitles: [exports.FIN_28_SHEET],
            },
        ];
    }
    if (stageCode === "subscriptions" ||
        stageCode === "contractual_docs" ||
        stageCode === "link_contractual_docs") {
        const helper = stageCode === "link_contractual_docs"
            ? {
                fin8: exports.LINK_CONTRACTUAL_DOC_FIN8_HELPER,
                fin27: exports.LINK_CONTRACTUAL_DOC_FIN27_HELPER,
            }
            : stageCode === "contractual_docs"
                ? {
                    fin8: exports.CONTRACTUAL_DOC_FIN8_HELPER,
                    fin27: exports.CONTRACTUAL_DOC_FIN27_HELPER,
                }
                : {
                    fin8: exports.SUBSCRIPTION_FIN8_HELPER,
                    fin27: exports.SUBSCRIPTION_FIN27_HELPER,
                };
        return [
            {
                key: "fin8SpreadsheetUrl",
                label: "P_FIN_2 spreadsheet",
                helperText: helper.fin8,
                requiredSheetTitles: [exports.FIN_8_SHEET],
            },
            {
                key: "fin27SpreadsheetUrl",
                label: "P_FIN_4 spreadsheet",
                helperText: helper.fin27,
                requiredSheetTitles: [exports.FIN_27_SHEET, exports.FIN_28_SHEET],
            },
        ];
    }
    return [
        {
            key: "spreadsheetUrl",
            label: "Spreadsheet URL",
            helperText: "",
            requiredSheetTitles: [],
        },
    ];
}
exports.getAcquisitionStageSpreadsheetFields = getAcquisitionStageSpreadsheetFields;
function normalizeAcquisitionName(name) {
    return name.trim().toLowerCase().replace(/\s+/g, " ");
}
exports.normalizeAcquisitionName = normalizeAcquisitionName;
function padStageOrder(order) {
    return String(order).padStart(3, "0");
}
exports.padStageOrder = padStageOrder;
/** UI / Input-sheet display id. DDB still stores the 8-char id without the prefix. */
function displayAcquisitionRequestId(id) {
    const stripped = String(id || "")
        .trim()
        .replace(/^ACQ-/i, "");
    return stripped ? `${exports.ACQ_PREFIX}-${stripped}` : "";
}
exports.displayAcquisitionRequestId = displayAcquisitionRequestId;
function toAcquisition(record) {
    return {
        acquisitionId: record.acquisitionId,
        name: record.name,
        ...(record.finSpreadsheetUrl
            ? { finSpreadsheetUrl: record.finSpreadsheetUrl }
            : {}),
        ...(record.subsidiary ? { subsidiary: record.subsidiary } : {}),
        ...(record.subsidiaryId ? { subsidiaryId: record.subsidiaryId } : {}),
        ...(record.jiraTicket ? { jiraTicket: record.jiraTicket } : {}),
        ...(record.comment ? { comment: record.comment } : {}),
        ...(record.createdByEmail ? { createdByEmail: record.createdByEmail } : {}),
        ...(record.createdByName ? { createdByName: record.createdByName } : {}),
        createdAt: record.createdAt,
        runCount: record.runCount || 0,
        ...(record.lastStageCode ? { lastStageCode: record.lastStageCode } : {}),
        ...(record.lastRunStatus ? { lastRunStatus: record.lastRunStatus } : {}),
        ...(record.lastRunAt ? { lastRunAt: record.lastRunAt } : {}),
        ...(record.workingSpreadsheetUrl
            ? { workingSpreadsheetUrl: record.workingSpreadsheetUrl }
            : {}),
    };
}
exports.toAcquisition = toAcquisition;
function toAcquisitionRun(record, extras) {
    return {
        acquisitionId: record.acquisitionId,
        runId: record.runId,
        status: record.status,
        input: record.input,
        output: record.output,
        createdAt: record.createdAt,
        ...(extras?.acquisitionName ? { acquisitionName: extras.acquisitionName } : {}),
    };
}
exports.toAcquisitionRun = toAcquisitionRun;
